.container {
  width: 100%;
}

.fieldwrapper {
  position: relative;
  /* min-width: 320px; */
  font-size: 16px;
  font-weight: 500;

  & .icon {
    position: absolute;
    top: 50%;
    left: 16px;
    transform: translateY(-50%);
    pointer-events: none;
    z-index: 3;
  }

  & input {
    position: relative;
    width: 100%;
    height: 56px;
    font-size: inherit;
    font-weight: 500;
    border: none;
    padding: 0 0 0 51px;
    border: 1px solid var(--color-black-10);
    border-radius: var(--border-radius);
    z-index: 2;

    &::placeholder {
      color: var(--color-black-30);
    }
  }
  &.hasError {
    & input {
      border-color: red !important;
      color: red !important;
    }
    & .charIcon {
      background-color: red;
    }
    & .icon {
      stroke: red;
    }
  }
  &.dropDownVisible {
    & input {
      border-radius: var(--border-radius) var(--border-radius) 0 0;
    }
    & .dropdown {
      display: block;
    }
  }
  &.dropDownVisible.upward {
    & input {
      border-radius: 0 0 var(--border-radius) var(--border-radius);
    }
  }
}

.dropdown {
  position: absolute;
  display: none;
  width: 100%;  
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  border-radius: 0 0 var(--border-radius) var(--border-radius);
  box-shadow: 0 20px 20px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  z-index: 1;

  &:not(.fullscreen) {
    top: 0;
    transform: translateY(-100%);
    border-radius: var(--border-radius) var(--border-radius) 0 0;
  }
}

.message {
  padding: 10px 20px;
  font-size: 15px;
  line-height: 1em;
  background: var(--color-yellow);
  color: black;
}

.scrollable {
  max-height: 260px; /* TODO: Use calc(5 * item-height) */
  overflow-y: scroll;
  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, .5);
    box-shadow: 0 0 1px rgba(255, 255, 255, .5);
  }
}

.item {
  font-size: inherit;
  padding: 0.5rem 20px;
  background: white;
  cursor: pointer;

  &.selected {
    background: var(--color-black-10);
  }

  @media (--hover) {
    &:hover {
      background: var(--color-black-10);
    }
  }
}

.dropDown {
  font-weight: 500;
  font-size:15px;
  display: flex;
  align-items: center;
}

.dropDownAddress {
  color:black;
  display: flex;
  flex-direction: column;
}

.dropDownAddress > span {
  font-weight: 400;
  color: rgba(0,0,0,0.7);
  font-size:12px;
  line-height: 10px;
}

.locationIcon {
  height:16px;
  margin-right:10px;
}

.locationbutton {
  position: absolute;
  right: 0;
  width: 40px;
  height: 100%;
  background-image: url("data:image/svg+xml,%3Csvg width='19' height='20' viewBox='0 0 19 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M15.7344 10C15.7344 13.4432 12.9432 16.2344 9.5 16.2344M15.7344 10C15.7344 6.55685 12.9432 3.76562 9.5 3.76562M15.7344 10H19M9.5 16.2344C6.05685 16.2344 3.26562 13.4432 3.26562 10M9.5 16.2344V19.5M3.26562 10C3.26562 6.55685 6.05685 3.76562 9.5 3.76562M3.26562 10H0M9.5 3.76562V0.5' stroke='black' stroke-opacity='0.3' stroke-width='2'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  background-position: center;
}

.charIcon {
  top: 50%;
  left: 16px;
  transform: translateY(-50%);
  cursor: pointer;
}

